

 export const GlobalName:any ={
    tokenName:"lmpToken",
    currentRoleIndex:"lmpRoleIndex",
    refreshTokenName:"lmpRefreshToken",
    userName:"lmpUserConnected",
    childName:"lmpChildSelected",
    exercice:"lmpExercise",
    expireIn:'lmpExpireIn',
    features:'lmpFeatures'
 }
